// API client helpers (axios) — provides GET/POST/DELETE for V2 endpoints.
// useApi already covers reactive GET; these helpers cover side-effects (mutations).
import axios from "axios";
import { API } from "@/modules/collector_v2/lib/api";

export async function apiGet(path) {
  const { data } = await axios.get(`${API}${path}`);
  return data;
}

export async function apiPost(path, body = null) {
  const { data } = await axios.post(`${API}${path}`, body);
  return data;
}

export async function apiDelete(path) {
  const { data } = await axios.delete(`${API}${path}`);
  return data;
}

// Convenience builders for Phase 6 endpoints.
export const v2 = {
  profile: (uid) => `/v2/users/${uid}/profile`,
  history: (uid, params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") search.set(k, String(v));
    });
    const qs = search.toString();
    return `/v2/users/${uid}/hands${qs ? `?${qs}` : ""}`;
  },
  handDetail: (handId) => `/v2/hands/${encodeURIComponent(handId)}`,
  replayData: (handId) => `/v2/hands/${encodeURIComponent(handId)}/replay-data`,
  collectionList: (uid) => `/v2/users/${uid}/collection`,
  collectionItem: (uid, handId) =>
    `/v2/users/${uid}/collection/${encodeURIComponent(handId)}`,
  searchUsers: (q, limit = 20) =>
    `/v2/users/search?q=${encodeURIComponent(q)}&limit=${limit}`,
  // Show Culture: detector de "exhibicionistas" (jugadores que muestran cartas
  // tras ganar sin showdown). Backend: ppk_v2_show_culture.
  showCultureProfile: (uid) => `/v2/show-culture/${uid}`,
  showCultureLeaderboard: (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") search.set(k, String(v));
    });
    const qs = search.toString();
    return `/v2/show-culture/leaderboard${qs ? `?${qs}` : ""}`;
  },
};
